// Which loaded tracks a Generate run still has to analyse.
//
// "Generate remaining" skips tracks that already have cues — found in the
// file / DJ app, or detected earlier this session — so a run stopped at track
// 900 of 4,000 picks up where it left off, and a library prepared by hand
// isn't re-analysed. Loops don't count as "prepared" unless the run is a
// loops-only run: a track that came out of this session's detection with
// cues but no loops has been analysed, and re-running it changes nothing.
// The per-row Generate ignores all this and always re-runs its one track.

const isLoop = (c) => c && c.type === 'loop';

// Serato (and some rips) leave one automatic marker at the very start of the
// file — that's not prep, and a track carrying only that is treated as having
// no cues.
export const LONE_MARKER_MS = 2000;

export function hasRealCues(cues) {
    const plain = (cues || []).filter((c) => c && !isLoop(c));
    if (!plain.length) return false;
    if (plain.length === 1 && (plain[0].positionMs || 0) < LONE_MARKER_MS) return false;
    return true;
}

export function hasLoops(cues) {
    return (cues || []).some(isLoop);
}

// mode: 'cues' | 'loops' | 'both' — the same value runGenerate takes.
export function needsRun(cues, mode) {
    if (mode === 'loops') return !hasLoops(cues);
    return !hasRealCues(cues);
}

export function remainingForRun(files, cuesByFile, mode) {
    return (files || []).filter((f) => needsRun((cuesByFile || {})[f], mode));
}
